export const getNotification = (state) => state.notification;
